import { IconButton } from '@healthhub/react-ui';
import { Drawer, Typography } from 'antd';
import type { ConfigType } from 'dayjs';

import { OutlinedLeftArrowIcon } from '@shared/assets-icon';

import type { FilterHandleFormProps } from '../FilterHandleForm/FilterHandleForm';
import FilterHandleForm from '../FilterHandleForm/FilterHandleForm';

interface FilterHandleDrawerProps extends FilterHandleFormProps {
  dateRangeDaysLimit: number;
  dateRangeOffset?: number;
  fixedEndDate?: ConfigType;
  fixedStartDate?: ConfigType;
  isVisible: boolean;
  maxDate?: ConfigType;
  minDate?: ConfigType;
  onToggleFilterDrawer: () => void;
}

const FilterHandleDrawer = ({
  dateRangeDaysLimit,
  dateRangeOffset,
  filterBtnText,
  fixedEndDate,
  fixedStartDate,
  form,
  handleResetFilters,
  initialValuesForm,
  isVisible,
  maxDate,
  minDate,
  onFinish,
  onToggleFilterDrawer,
}: FilterHandleDrawerProps) => (
  <Drawer
    className="[&_.ant-drawer-header]:border-b-2 [&_.ant-drawer-header]:border-theme-100 [&_.ant-drawer-header]:p-5"
    closeIcon={null}
    onClose={onToggleFilterDrawer}
    open={isVisible}
    placement="right"
    title={
      <>
        <IconButton
          aria-label="Back"
          className="absolute left-4"
          icon={<OutlinedLeftArrowIcon className="size-6" />}
          onClick={onToggleFilterDrawer}
        />
        <div className="flex justify-center">
          <Typography.Text className="mr-4 w-full text-center text-base font-semibold">Filters</Typography.Text>
        </div>
      </>
    }
    width="100%"
  >
    <FilterHandleForm
      dateRangeDaysLimit={dateRangeDaysLimit}
      dateRangeOffset={dateRangeOffset}
      filterBtnText={filterBtnText}
      fixedEndDate={fixedEndDate}
      fixedStartDate={fixedStartDate}
      form={form}
      handleResetFilters={handleResetFilters}
      initialValuesForm={initialValuesForm}
      maxDate={maxDate}
      minDate={minDate}
      onFinish={onFinish}
    />
  </Drawer>
);

export default FilterHandleDrawer;
